<template>
  <div style="text-align: center;">
    <div>
      <div class="main">
        <div class="filters">
          <b-button-group>
            <!-- <b-button
              class="buttons-filters"
              @click="profile = 'all'"
              v-bind:class="{
                active: profile === 'all',
              }"
              >Todos</b-button
            > -->
            <b-button
              class="buttons-filters"
              @click="profile = 'promoters'"
              v-bind:class="{
                active: profile === 'promoters',
              }"
              >Promotores</b-button
            >
            <b-button
              class="buttons-filters"
              @click="profile = 'neutral'"
              v-bind:class="{
                active: profile === 'neutral',
              }"
              >Neutros</b-button
            >
            <b-button
              class="buttons-filters"
              @click="profile = 'detractors'"
              v-bind:class="{
                active: profile === 'detractors',
              }"
              >Detratores</b-button
            >
          </b-button-group>
        </div>
      </div>
    </div>

    <div class="col-12">
      <div class="row" style="margin-top: 25px;">
        <div
          style="align-items: center; justify-content: center;"
          class="col-12 text-center"
        >
          <i
            @click="type = 'dots'"
            v-bind:class="{
              active: type === 'dots',
            }"
            class="fas fa-comment-dots icon"
          ></i>
          <i
            @click="type = 'table'"
            v-bind:class="{
              active: type === 'table',
            }"
            class="fas fa-table icon"
          ></i>
        </div>
        <div v-if="type === 'dots'" class="col-12">
        <div v-if="loader" class="pt-3">
          <idx-skeleton-chart type="words"/>
        </div>
          <wordcloud
            :rotate="{ from: -90, to: 90, numOfOrientation: 5 }"
            data-group="promoters"
            :data="data"
            nameKey="name"
            valueKey="value"
            :color="promotersColors"
            :showTooltip="true"
          ></wordcloud>
        </div>
        <div
          v-if="type === 'table'"
          class="col-12 table-align"
          id="table"
          :style="`height: ${heightTable}px; overflow-x: hidden; font-size: 12px;`"
        >
          <div v-if="loader">
            <table style="font-size: 12px;">
              <tr>
                <th :style="`width: ${wightTable}px`">
                  Ranking de palavras
                </th>
                <th :style="`width: ${wightTable}px`">Amostra</th>
              </tr>
              <tr>
                <td align="center">
                  <idx-skeleton class="m-1" width="80" height="10" radius="8" />
                </td>
                <td align="center">
                  <idx-skeleton class="m-1" width="25" height="10" radius="8" />
                </td>
              </tr>
              <tr>
                <td align="center">
                  <idx-skeleton
                    class="m-1"
                    width="120"
                    height="10"
                    radius="8"
                  />
                </td>
                <td align="center">
                  <idx-skeleton class="m-1" width="25" height="10" radius="8" />
                </td>
              </tr>
              <tr>
                <td align="center">
                  <idx-skeleton
                    class="m-1"
                    width="130"
                    height="10"
                    radius="8"
                  />
                </td>
                <td align="center">
                  <idx-skeleton class="m-1" width="25" height="10" radius="8" />
                </td>
              </tr>
              <tr>
                <td align="center">
                  <idx-skeleton class="m-1" width="80" height="10" radius="8" />
                </td>
                <td align="center">
                  <idx-skeleton class="m-1" width="25" height="10" radius="8" />
                </td>
              </tr>
              <tr>
                <td align="center">
                  <idx-skeleton
                    class="m-1"
                    width="120"
                    height="10"
                    radius="8"
                  />
                </td>
                <td align="center">
                  <idx-skeleton class="m-1" width="25" height="10" radius="8" />
                </td>
              </tr>
              <tr>
                <td align="center">
                  <idx-skeleton
                    class="m-1"
                    width="130"
                    height="10"
                    radius="8"
                  />
                </td>
                <td align="center">
                  <idx-skeleton class="m-1" width="25" height="10" radius="8" />
                </td>
              </tr>
            </table>
          </div>
          <table style="font-size: 12px;" v-else>
            <tr>
              <th :style="`width: ${wightTable}px`">
                Ranking de palavras
              </th>
              <th :style="`width: ${wightTable}px`">Amostra</th>
            </tr>
            <tr v-for="(item, i) in data" :key="i">
              <td>{{ item.name }}</td>
              <td>{{ item.value }}</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import idxSkeleton from '@/components/molecules/idx-skeleton';
import idxSkeletonChart from '@/components/molecules/idx-skeleton-chart';
import wordcloud from 'vue-wordcloud';
import listAnswers from '../list-answers';
import api from '../../../../../services/api';

export default {
  name: 'app',
  components: {
    wordcloud,
    listAnswers,
    idxSkeleton,
    idxSkeletonChart,
  },

  props: ['dataGraph'],

  watch: {
    profile: function watchProfile(value) {
      if (value === 'all') {
        this.data = this.allData;
      } else if (value === 'promoters') {
        this.data = this.promoters;
      } else if (value === 'detractors') {
        this.data = this.detractors;
      } else {
        this.data = this.neutrals;
      }
    },

    'dataGraph.layout': function watchLayoutConfig(value) {
      const word = document.querySelector('.wordCloud');

      if (value.h >= 22) {
        this.heightTable = value.h * 5;
        this.wightTable = value.w * 40;
      } else {
        this.heightTable = value.h * 25;
        this.wightTable = value.w * 60;
      }

      word.setAttribute('style', `height: ${value.h * 25}px`);
    },
  },
  data: () => ({
    group: null,
    promotersColors: ['#4ce595', '#5ff5a7', '#71f0ae', '#8af2bc'],
    neutralsColors: ['#ffca27', '#fad04d', '#fcdb72', '#fce59a'],
    detractorsColors: ['#d62027', '#db3b41', '#db565b', '#f59599'],
    wordSelected: null,
    promoters: [],
    neutrals: [],
    detractors: [],
    loader: false,
    profile: 'promoters',
    data: [],
    allData: [],
    heightTable: 1,
    wightTable: 1,
    type: 'dots',
  }),

  methods: {
    ...mapActions('charts', ['setWordCloud']),

    async getWordCloud() {
      this.loader = true;
      const response = await api.get(`/wordcloud-panel`, {
        headers: { 'x-access-token': this.userAuth.token },
        params: {
          companyId: this.userAuth.companyId,
          token: this.userAuth.token,
          actionId: this.dataGraph.actionId
            ? this.dataGraph.actionId._id
            : null,
         // startDate: '2021-01-01',
          //endDate: '2021-12-31',
          ih1: this.dataGraph.ih1 && this.dataGraph.ih1.length > 0 ? this.dataGraph.ih1.map((item) => item._id): null,
          metric: this.dataGraph.metric,
          groupId: this.dataGraph.actionGroupId
            ? this.dataGraph.actionGroupId._id
            : null,
          indicator: this.dataGraph.indicator ? this.dataGraph.indicator : null,
          indicatorValue: this.dataGraph.valueIndicator,
          period: this.dataGraph.period,
          _id: this.dataGraph._id,
        },
      });

      this.promoters = response.data.promoters;
      this.neutrals = response.data.neutrals;
      this.detractors = response.data.detractors;

      this.promoters.forEach((el) => {
        this.allData.push({
          value: el.value,
          name: el.name,
        });
      });

      this.neutrals.forEach((el) => {
        this.allData.push({
          value: el.value,
          name: el.name,
        });
      });

      this.detractors.forEach((el) => {
        this.allData.push({
          value: el.value,
          name: el.name,
        });
      });

      this.data = this.promoters;
      this.loader = false;
    },
  },
  created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));

    this.getWordCloud();
  },
  async mounted() {
    this.loader = true;

    if (this.dataGraph.layout.h >= 22) {
      this.heightTable = this.dataGraph.layout.h * 20;
      this.wightTable = this.dataGraph.layout.w * 40;
    } else {
      this.heightTable = this.dataGraph.layout.h * 25;
      this.wightTable = this.dataGraph.layout.w * 60;
    }

    this.getWordCloud();
  },
};
</script>

<style scoped lang="scss">
@import '@/themes/default/variables.scss';
.table-align {
  display: inline-grid;
  align-items: center;
  justify-content: center;
}

.icon {
  font-size: 20px;
  color: #e8e8e8;
  cursor: pointer;
}

.icon.active {
  color: #5e5e5e;
  font-size: 20px;
  cursor: pointer;
}

.wordCloud {
  display: inline-block;
  position: relative;
  width: 100%;
  height: 225px;
}

tr {
  border-bottom: 2px solid #f1f1f1;
}

.filters {
  background: #f0f6fb;
  padding-left: 20px;
  padding-right: 20px;
  border-radius: 20px;
  margin-top: 12px;
}

.main {
  display: flex;
  padding: 0;
  align-items: center;
  justify-content: center;
  width: 100%;
}

:hover {
  text-decoration: none;
}

.buttons-filters {
  background: #f0f6fb;
  border-radius: 50rem;
  padding-left: 15px;
  padding-right: 15px;
  border: none;
  outline: none;
  font-size: 12px;
}

.buttons-filters.active {
  background: #fff !important;
  border-radius: 50rem !important;
  padding-left: 15px !important ;
  padding-right: 15px !important;
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
  font-weight: bold !important;
}

.word-cloud {
  .col-4 {
    p {
      font-size: 1.2em;
      font-weight: 100;
      color: $title-color;
      position: relative;
      padding-left: 15px;
      margin-left: 16px;
      text-transform: uppercase;
      span {
        position: absolute;
        width: 4px;
        height: 25px;
        left: 0;
        top: 3px;
      }
    }
  }
}

.tooltip {
  min-width: 250px !important;
  max-width: 500px !important;
  min-height: 100px !important;
}

.list-answers {
  min-height: 280px;
}

.loader {
  width: 100%;
  height: 350px;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/highcharts/word-cloud/panels/word-cloud.vue